import * as React from 'react';
import { useContext } from 'react';
import { Query } from '@apollo/client/react/components';
import styled from 'styled-components';
import { DashboardFilterContext } from '../../containers/serviceProvider/Dashboard';
import { DASHBOARD_DATA } from '../../graphql';
import { isUndefined } from '../../utils';
import { OperationVariables, QueryResult } from '@apollo/client';

const Row = styled.div`
  background-color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.space[2]}px;
  margin-bottom: ${props => props.theme.space[0]}px;
  display: flex;
  justify-content: space-between;
`;

const DashboardStatsOverview = () => {
  const contextData = useContext(DashboardFilterContext);
  const input = Object.values(contextData).every(isUndefined)
    ? {}
    : {
        ...contextData,
        gradeIds: contextData.gradeIds && contextData.gradeIds.length > 0 ? contextData.gradeIds : undefined,
      };

  return (
    <Query query={DASHBOARD_DATA} variables={{ input }}>
      {({ loading, error, data }: QueryResult<any, OperationVariables>) => {
        return (
          <React.Fragment>
            <Row>
              Provinces <span>{loading || error ? '-' : data.totalProvinces}</span>
            </Row>
            <Row>
              Districts <span>{loading || error ? '-' : data.totalDistricts}</span>
            </Row>
            <Row>
              Schools <span>{loading || error ? '-' : data.totalInstitutions}</span>
            </Row>
            <Row>
              Stakeholders <span>{loading || error ? '-' : data.totalBeneficiaries}</span>
            </Row>
            <Row>
              Learners <span>{loading || error ? '-' : data.totalLearners}</span>
            </Row>
            <Row>
              Service Providers <span>{loading || error ? '-' : data.totalServiceProviders}</span>
            </Row>
            <Row>
              Intervention Types <span>{loading || error ? '-' : data.totalInterventionTypes}</span>
            </Row>
          </React.Fragment>
        );
      }}
    </Query>
  );
};

export default DashboardStatsOverview;
